import React, { Component } from 'react';
import styled from 'styled-components';
import { Subtitle, Text } from '../../components/style';
import { dark, primary, white } from 'react-components/dist/values/colors/colors';

const Wrapper = styled.div`
  height: ${props => (props.first ? 90 : 70)}vh;
  position: relative;
  background-image: url(${props => props.backgroundImage});
  background-size: cover;
  background-position: center;
  z-index: 1;
  margin-bottom: 0;
  transition: 0.3s all;
`;

const Preview = styled.video`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

const Overlay = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
`;

const ButtonContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  text-align: center;
`;

const PlayIcon = styled.div`
  height: 84px;
  width: 84px;
  margin: 12px 0;
  & path {
    fill: none;
    stroke: ${primary};
  }
  & rect {
    fill: none;
  }
  &:hover {
    cursor: pointer;
    & rect {
      fill: ${primary};
    }
    & path {
      fill: ${primary};
      stroke: ${white};
    }
  }
`;

const VideoContainer = styled.div`
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-content: center;
  display: ${props => (props.show ? 'flex' : 'none')};
  & iframe {
    max-width: 100%;
    border: 0;
  }
`;
const Inner = styled.div`
  background-color: ${white};
  box-sizing: border-box;
  padding: 24px;
  background-color: white;
  border-radius: 24px;
`;

const Close = styled.div`
  height: 32px;
  width: 32px;
  background-color: ${dark}
  position: absolute;
  top: -12px;
  right: -12px;
  border-radius: 50%;
  color: ${white};
  padding: 6px;
  box-sizing: border-box;
  &:hover{
    cursor: pointer;
    background-color: ${dark + '90'}
  }
  & > svg{
    height: 100%;
    width: 100%;
  }
`;

class Video extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: this.props.active
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.opened) window.history.pushState(null, this.props.post.title, this.props.post.url);
  }

  render() {
    return (
      <Wrapper first={this.props.index === 0}>
        <Preview
muted
autoPlay
loop>
          <source
src={this.props.post.videoPreview}
type="video/mp4" />
        </Preview>
        <Overlay />
        <ButtonContainer>
          <Subtitle
color={white}
text={this.props.post.title} />
          <PlayIcon
            onClick={() => {
              this.setState({ opened: true });
            }}
          >
            <svg
xmlns="http://www.w3.org/2000/svg"
viewBox="0 0 115 115">
              <rect
                x="1.5"
                y="1.5"
                width="112"
                height="112"
                rx="56"
                ry="56"
                stroke={primary}
                strokeMiterlimit="10"
                strokeWidth="3"
              />
              <path
                d="M81.45,55.7,48,36.39a2.08,2.08,0,0,0-3.12,1.8V76.81A2.08,2.08,0,0,0,48,78.61L81.45,59.3A2.08,2.08,0,0,0,81.45,55.7Z"
                strokeMiterlimit="10"
                strokeWidth="3"
              />
            </svg>
          </PlayIcon>
          <Text
text={window.lang === 'fr' ? 'Visionnez!' : 'Watch!'}
color={white} />
        </ButtonContainer>
        <VideoContainer
          show={this.state.opened}
          onClick={() => {
            this.setState({ opened: false });
          }}
        >
          {this.state.opened ? (
            <div style={{ position: 'relative', maxWidth: 'calc(100% - 28px)' }}>
              <Inner
                onClick={e => {
                  e.stopPropagation();
                }}
                dangerouslySetInnerHTML={{ __html: this.props.post.content }}
              />
              <Close
                onClick={() => {
                  this.setState({ opened: false });
                }}
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="times"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 352 512"
                >
                  <path
                    fill="currentColor"
                    d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                  />
                </svg>
              </Close>
            </div>
          ) : (
            <></>
          )}
        </VideoContainer>
      </Wrapper>
    );
  }
}

export default Video;
